import Vue from 'vue'
import Router from 'vue-router'
import NotFoundComponent from '@/components/NotFoundComponent'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      component: NotFoundComponent
    }, {
      alias: '/',
      path: '/urlcomplain',
      name: 'urlcomplain',
      component: resolve => require(['@/containers/urlcomplain/HomePage.vue'], resolve)
    }, {
      alias: '/',
      path: '/urlcomplain/add_cert',
      name: 'add_cert',
      component: resolve => require(['@/containers/urlcomplain/AddCert.vue'], resolve)
    }, {
      path: '/urlcomplain/site_certify',
      name: 'site_certify',
      component: resolve => require(['@/containers/urlcomplain/siteCertify.vue'], resolve)
    }, {
      path: '/urlcomplain/submit_success',
      component: resolve => require(['@/containers/urlcomplain/SubmitSuccess.vue'], resolve)
    }, {
      path: '/urlcomplain/query_status',
      component: resolve => require(['@/containers/urlcomplain/QueryStatus.vue'], resolve)
    }, {
      path: '/urlcomplain/form',
      component: resolve => require(['@/containers/urlcomplain/UrlComplain.vue'], resolve)
    }, {
      path: '/urlcomplain/anxin',
      component: resolve => require(['@/containers/urlcomplain/AnxinPage.vue'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js